import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Resource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  assignEveryoneToManager(
    request: Boundaries["assignEveryoneToManager"]["request"],
  ): void;
}

function useAssignEveryoneToManager(
  manager: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAssignEveryoneToManagerRequestPending(manager),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAssignEveryoneToManagerRequestSuccess(manager),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAssignEveryoneToManagerRequestFailure(manager),
    ),
    assignEveryoneToManager: core.assignEveryoneToManager,
  };
}

export { useAssignEveryoneToManager };
